// extracted by mini-css-extract-plugin
export default {"btn_politica_inversion":"politica-inversion_btn_politica_inversion__KXe9M","spn_politica_inversion":"politica-inversion_spn_politica_inversion__o81t4"};